module.exports = __webpack_public_path__ + "static/Ranking_background-d8bbe7e5dd7fc769199f6c6f7415ee87.png";